import React, { FC, memo, useEffect } from 'react';
import { IMyOrder } from '../../../redux/user/user.duck.interface';
import { DealPreview } from '@components/DealPreview/DealPreview';
import MyOrder from '@components/DealPreview/components/MyOrder';
import Paginator, { IPaginatorPage } from '@components/Paginator';
import { useCustomRouter } from '@hooks/useCustomRouter';
import { useTranslations } from '@hooks/useTranslations';
import { useUserDuck } from '@hooks/useUserDuck';
import routes from '../../../constants/routes';
import { MyAccountSidebar } from '@components/MyAccountSidebar';
import { useGTM } from '@hooks/useGTM';

const MyOrdersController: FC = memo(() => {
    const router = useCustomRouter();
    const { pushMyOrdersPageLoad } = useGTM();
    const { t } = useTranslations();
    const {
        myOrders,
        summary: { totalOrders },
        page,
        perPage,
    } = useUserDuck();

    const handlePageClick = ({ selected }: IPaginatorPage) => {
        window.scrollTo(0, 0);
        const newPage: number = selected + 1;
        const queryPage = newPage === 1 ? '' : '?page=' + newPage;
        router.push(routes.MY_ORDERS + queryPage);
    };
    if (myOrders.items.length === 0) {
        return (
            <div className="nothing-found">
                <h1>{t('myaccount.deal.nothingFound')}</h1>
            </div>
        );
    }
    useEffect(() => {
        if (myOrders.items) pushMyOrdersPageLoad(myOrders.items);
    }, [myOrders]);

    return (
        <div className="my-account-box">
            <div className="my-orders">
                {myOrders.items.map(
                    (myOrder: IMyOrder, key) =>
                        (myOrder?.sibling?.fullProductConfiguration?.pricesV2 ||
                            myOrder?.sibling?.fullProductConfiguration?.extraFields?.pricesV2) && (
                            <DealPreview id={key === 0 && `skip-to-content`} key={myOrder.orderId}>
                                <MyOrder myOrder={myOrder} />
                            </DealPreview>
                        )
                )}
                {totalOrders.total > perPage && (
                    <Paginator
                        page={page}
                        handlePageClick={handlePageClick}
                        total={totalOrders.total}
                        perPage={perPage}
                    />
                )}
            </div>
            <div className="my-account-menu">
                <MyAccountSidebar />
            </div>
        </div>
    );
});
MyOrdersController.displayName = 'MyOrdersController';
export default MyOrdersController;
